var map = {
	"./kovy.webp": "39fc",
	"./kovy@2x.webp": "f82f",
	"./papir.webp": "e328",
	"./papir@2x.webp": "3e98",
	"./pet.webp": "2096",
	"./pet@2x.webp": "305b",
	"./sklo.webp": "6916",
	"./sklo@2x.webp": "6bbb",
	"./smesny.webp": "6d63",
	"./smesny@2x.webp": "1109",
	"./tetra.webp": "a081",
	"./tetra@2x.webp": "5334"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d4ab";